import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-[#FFF5F5] border-brand-pink/30',
    icon: '📘',
    title: 'Tomo 1 — El Despertar (Días 1 al 30)',
    subtitle: 'Descubrís por qué el dinero se escapa aunque trabajes más. Disolvés los contratos de pobreza que heredaste sin saberlo y activás tu primera frecuencia de abundancia.',
    outcome: 'Decreto de Cancelación · EFT Financiero · Diario Vibracional · Planilla 30 días'
  }, {
    color: 'bg-[#F8FAF9] border-brand-green/20',
    icon: '📗',
    title: 'Tomo 2 — Limpieza Cuántica (Días 31 al 60)',
    subtitle: 'Eliminás las creencias limitantes en 5 capas. Instalás el Escudo Vibracional como hábito diario y aprendés a no dejar que la inflación te baje la frecuencia.',
    outcome: 'Escritura Liberadora · Ritual de Quema · Protocolo Anti-Devaluación · Escudo Vibracional'
  }, {
    color: 'bg-[#FFF9F2] border-brand-gold/20',
    icon: '📙',
    title: 'Tomo 3 — El Imán de Dinero (Días 61 al 90)',
    subtitle: 'Activás tu campo de atracción con visualizaciones de alta frecuencia. Creás tus Decretos Cuánticos personales y abrís los primeros 3 canales de ingreso.',
    outcome: 'Película Mental de Abundancia · Decretos Cuánticos Compuestos · Mapa de 3 Canales'
  }, {
    color: 'bg-[#FDF8F8] border-brand-pink/20',
    icon: '📕',
    title: 'Tomo 4 — Ingeniería de Riqueza (Días 91 al 120)',
    subtitle: 'Armás tu primer presupuesto consciente real. Identificás tu Deuda #1 y calculás exactamente cuándo la liquidás. El dinero deja de desaparecer.',
    outcome: 'Presupuesto 5 Capas · Bola de Nieve Vibracional · 3 Fondos de Libertad · Mapa de Salida de Deudas'
  }, {
    color: 'bg-[#F5FAFA] border-cyan-200',
    icon: '📓',
    title: 'Tomo 5 — Expansión de Canales (Días 121 al 150)',
    subtitle: 'Multiplicás tus ingresos más allá del sueldo fijo. Activás tu red de valor, aprendés a negociar desde el poder y lanzás tu canal semi-pasivo.',
    outcome: 'Red de Valor · Script de Negociación · Hora del Emprendedor · Estrategia Digital'
  }, {
    color: 'bg-[#F6F9F7] border-brand-green/30',
    icon: '📔',
    title: 'Tomo 6 — El Sello de Abundancia (Días 151 al 180)',
    subtitle: 'Sellás tu transformación y blindás tu nueva realidad financiera para que no haya vuelta atrás. Creás tu Visión de 5 Años y tu Legado Financiero.',
    outcome: 'Ritual de Sello · Plan Blindaje 365 · Visión 5 Años · Decreto Maestro de Abundancia'
  }];
  const checklist = ['Actividades diarias de menos de 10 minutos', 'Decretos y planillas listos para usar', 'Protocolos de emergencia para momentos de crisis', '100% adaptado a la realidad económica argentina'];
  return <Section id="method" data-id="element-188">
      <div className="text-center mb-16" data-id="element-189">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-gold/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-190">
          <span className="text-xl" data-id="element-191">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-gold text-sm md:text-base" data-id="element-192">
            MEGAPACK CÓDIGO DE ABUNDANCIA™
          </span>
        </div>
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-193">
          6 Tomos + 2 Bonus — 180 días de transformación
        </h2>
        <p className="text-brand-muted text-[18px] mb-2" data-id="element-194">
          Primeros resultados visibles: 30 días. Transformación financiera
          completa: 180 días. Herramientas para usar de por vida: para siempre.
        </p>
        <p className="text-brand-gold/80 font-medium" data-id="element-195">
          410+ páginas — Todo resuelto.
        </p>
      </div>

      <h3 className="text-2xl font-serif font-bold text-center gold-gradient-text mb-[35px]" data-id="element-196">
        6 TOMOS COMPLETOS
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-197">
        {tomos.map((tomo, i) => <div key={i} className={`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm pt-[15px] pb-[15px] pl-[15px] pr-[15px]`} data-id="element-198">
            <div className="text-3xl mb-3" data-id="element-199">{tomo.icon}</div>
            <h4 className="font-serif font-bold mb-2 text-[15px] text-brand-gold" data-id="element-200">
              {tomo.title}
            </h4>
            <p className="text-brand-text/90 font-medium mb-4 text-[14px]" data-id="element-201">
              {tomo.subtitle}
            </p>
            <p className="text-brand-text/70 text-[12px]" data-id="element-202">
              <span className="font-bold text-brand-green" data-id="element-203">Lo que hacés:</span>{' '}
              {tomo.outcome}
            </p>
          </div>)}
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto pt-[30px] pb-[30px] pl-[30px] pr-[30px] mb-[90px]" data-id="element-204">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-205">
          Todos los tomos incluyen:
        </h4>
        <ul className="space-y-4" data-id="element-206">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-207">
              <Check className="w-5 h-5 text-brand-gold mr-3 mt-0.5 shrink-0" data-id="element-208" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-209">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-12" data-id="element-210">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-211">
          🎁 2 BONUS ESTRATÉGICOS
        </h3>
        <p className="text-brand-muted text-lg" data-id="element-212">SIEMPRE INCLUIDOS</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-213">
        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden pt-[20px] pb-[20px] pl-[20px] pr-[20px]" data-id="element-214">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-215">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-216" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-217">
            BONUS 1 — El Planificador Infinito
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-1" data-id="element-218">
            Calendario de Mantenimiento 365
          </p>
          <p className="text-brand-text/80 text-sm mb-3" data-id="element-219">
            Tu herramienta de vida próspera para usar mes a mes, de por vida.
            Plantilla mensual reutilizable, Tracker de Decretos, Auditoría
            Mensual y Registro Trimestral de Metas.
          </p>
          <div className="text-sm" data-id="element-220">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-221">
              Valor real: $15.000 ARS
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-222">→ GRATIS</span>
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden" data-id="element-223">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-224">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-225" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-226">
            BONUS 2 — La Bitácora de Sincronías
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-1" data-id="element-227">
            Rastreador de Milagros Financieros
          </p>
          <p className="text-brand-text/80 text-sm mb-3" data-id="element-228">
            Tu registro sagrado de cada señal que el universo te envía. Detector
            de Micro-Abundancia, Termómetro de Alineación semanal y Muro de
            Evidencias Anuales.
          </p>
          <div className="text-sm" data-id="element-229">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-230">
              Valor real: $12.000 ARS
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-231">→ GRATIS</span>
          </div>
        </div>
      </div>

      <div className="text-center mt-8" data-id="element-232">
        <p className="font-medium bg-brand-surfaceLight/50 inline-block px-6 py-3 rounded-full border border-brand-gold/20 text-[12px]" data-id="element-233">
          Valor total bonos:{' '}
          <span className="line-through text-brand-text/50 mx-1 text-[12px]" data-id="element-234">
            $27.000 ARS
          </span>{' '}
          <span className="text-brand-gold font-bold" data-id="element-235">
            → GRATIS con tu MegaPack
          </span>
        </p>
      </div>
    </Section>;
};